import { FetchSensorsForSensorGroupQuery, FetchGraphSensorsQuery } from 'app/__generated__/global';
import ISensor from 'app/business-logic/domain-models/ISensor';
import Guid from 'core/types/Guid';

type BySensorGroup = NonNullable<
  FetchSensorsForSensorGroupQuery['facility']
>['measurementGroups'][number]['processVariables'][number];

// This is a bit gross, wonder if a type can be specified on the backend and generated to be imported here instead
type ByMonitorId = NonNullable<
  NonNullable<
    Exclude<
      NonNullable<FetchGraphSensorsQuery['facility']>['processes'][number],
      { __typename?: 'SimpleProcess'; id: string } | { __typename?: 'SourceAreaProcess'; id: string }
    >['displayConfig']
  >['graphVariables'][number]['processVariable']
>;

type ProcessVariableGraphType = BySensorGroup | ByMonitorId;

export const convertToSensor = {
  from: (processVariableGraphType: ProcessVariableGraphType, sensorGroupId: Guid | null = null) => {
    const {
      id,
      name,
      displayUnit,
      thresholds,
      process,
      influenceArcDisplayThreshold,
      samplingRateSeconds,
      staleDataTimeoutSeconds,
      numericScale,
      temporalThresholdGroup,
    } = processVariableGraphType;

    if (!process) return null;

    const displayVariableThresholds = thresholds
      .map(({ valueInDisplayUnit, hexColor }) => {
        return {
          max: valueInDisplayUnit,
          color: hexColor,
        };
      })
      .sort((left, right) => left.max - right.max);

    return {
      id,
      name,
      unitName: displayUnit?.name ?? '-',
      monitorId: process.id,
      monitorName: process.name,
      sensorGroupId,
      thresholds: displayVariableThresholds,
      samplingRateSeconds,
      staleDataTimeoutSeconds,
      influenceArcDisplayThreshold,
      numericScale,
      temporalThresholdGroup,
    } satisfies ISensor;
  },
};
